/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CopyMasterScheduleRequest } from '../../models/copy-master-schedule-request';
import { CopyMasterScheduleResponse } from '../../models/copy-master-schedule-response';

export interface CopyMasterSchedule$Params {
      body: CopyMasterScheduleRequest
}

export function copyMasterSchedule(http: HttpClient, rootUrl: string, params: CopyMasterSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<CopyMasterScheduleResponse>> {
  const rb = new RequestBuilder(rootUrl, copyMasterSchedule.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CopyMasterScheduleResponse>;
    })
  );
}

copyMasterSchedule.PATH = '/api/scheduler/master-schedule/copy-schedule';
